import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { CAUSED_SERVICE_OUTAGE } from '../form-definition/section-constants';

const fieldId = CAUSED_SERVICE_OUTAGE;

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  // errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true } : null);
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option here.' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = [];

const vFParams = {
  multiSelect: false,
  fieldTitle: 'Did this cause a service Outage?',
};

const causedServiceOutage = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { causedServiceOutage };
